var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAttach(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7716 3.74346C14.113 1.39988 17.912 1.39988 20.2552 3.74302C22.5382 6.02609 22.5968 9.6913 20.4308 12.0452L20.2426 12.2426L11.4426 21.0408L11.406 21.071C9.9448 22.3878 7.6908 22.3431 6.28343 20.9357C4.96441 19.6167 4.84229 17.554 5.91708 16.0973C5.94042 16.0519 5.96867 16.0082 6.00188 15.967L6.05544 15.9074L6.14234 15.8197L6.28343 15.6718L6.28634 15.6747L13.7221 8.22035C13.988 7.95373 14.4046 7.92897 14.6985 8.14643L14.7827 8.21894C15.0494 8.48485 15.0741 8.90148 14.8567 9.19538L14.7842 9.2796L7.18953 16.8927C6.4719 17.7683 6.52178 19.0626 7.33917 19.88C8.16824 20.709 9.48789 20.7485 10.3637 19.9984L19.1964 11.1679C20.9519 9.41028 20.9519 6.56104 19.1945 4.80368C17.4921 3.10124 14.7649 3.04804 12.9984 4.64408L12.8305 4.80368L12.818 4.81799L3.28167 14.3543C2.98878 14.6472 2.51391 14.6472 2.22101 14.3543C1.95475 14.0881 1.93054 13.6714 2.14839 13.3778L2.22101 13.2937L11.7699 3.74302L11.7716 3.74346Z",
    fill: "#4A4A49"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttach);
export default __webpack_public_path__ + "static/media/attach.d385ad88d593cf533252cae0da6e55f4.svg";
export { ForwardRef as ReactComponent };